import { useEffect, useState } from "react";
import { Table } from "@tw/tw-common-js";
import { formatDate } from "../../services/utils";
import api from "../../services/api";

export default function RoleAssignmentHistory({ hrCode }) {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    async function fetchLogs() {
      try {
        const res = await api.getUserRoleAuditLog(hrCode);
        if (res.status === 200) setLogs(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        console.error("Error fetching role assignment history:", err);
      }
    }
    if (hrCode) fetchLogs();
  }, [hrCode]);

  const config = {
    columns: [
      { key: "date", header: "Date", template: (row) => formatDate(row.date, true) },
      { key: "action", header: "Action", template: (row) => (row.action === "assigned" ? "Assigned" : "Unassigned") },
      { key: "roleName", header: "Role", template: (row) => row.roleName || "-" },
      { key: "actorLabel", header: "Changed By", template: (row) => row.actorLabel || "-" },
    ],
  };

  return (
    <div className="table-container with-borders no-vertical-scroll">
      <Table
        data={logs}
        config={config}
        emptyMessage="No role assignment changes recorded."
        className="changelog-table"
        enableColumnVisibility={false}
        enableColumnOrdering={false}
        hideIcon={true}
      />
    </div>
  );
}
